if (customElements.get('aiw-autoship-toggle') === undefined) {
  class AiwAutoshipToggle extends HTMLElement {
    constructor() {
      super();
      this.onClick = this.onClick.bind(this);
    }

    connectedCallback() {
      this.scope = this.closest('.aiw-v2-main-product') || document;
      this.scope.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      if (this.scope) this.scope.removeEventListener('click', this.onClick);
    }

    selectOneTime() {
      const oneTimeRadio = this.scope.querySelector('.purchase-option--one-time .purchase-option__radio');
      if (!oneTimeRadio) {
        if (typeof console !== 'undefined') console.warn('[aiw-autoship-toggle] one-time radio missing — deselect inert');
        return;
      }
      oneTimeRadio.checked = true;
      oneTimeRadio.dispatchEvent(new Event('change', { bubbles: true }));
    }

    onClick(e) {
      // "No thanks" button inside the open AutoShip card
      if (e.target.closest('[data-purchase-option-deselect]')) {
        e.preventDefault();
        this.selectOneTime();
        return;
      }

      // ::before overlay on a checked AutoShip card.
      // Pseudo-elements aren't event targets, so the click fires on the
      // .purchase-option__inner element itself when the ::before is clicked.
      if (e.target.classList.contains('purchase-option__inner')) {
        const po = e.target.closest('.purchase-option');
        if (po && po.classList.contains('purchase-option--checked') && !po.classList.contains('purchase-option--one-time')) {
          e.preventDefault();
          this.selectOneTime();
        }
      }
    }
  }

  customElements.define('aiw-autoship-toggle', AiwAutoshipToggle);
}
